module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-profile-page",
    class: [{
      'no-margin-top': _vm.embedded,
      'no-padding-top': _vm.embedded
    }]
  }, [_c('div', {
    staticClass: "container edit-user-template"
  }, [(!_vm.embedded) ? _c('h1', {
    staticClass: "page-header color-1-100"
  }, [(_vm.canEditBillingContact) ? [_vm._v("\n        Edit billing profile\n      ")] : [_vm._v("\n        Billing profile\n      ")]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-block",
    class: [{
      'no-margin-top': _vm.embedded,
      'no-padding-top': _vm.embedded
    }]
  }, [_c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [(_vm.currentPlan && _vm.currentPlan.plan) ? _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'subscriptionDetails'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('subscriptionDetails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "19.25",
      "height": "22",
      "viewBox": "0 0 19.25 22"
    }
  }, [_c('path', {
    attrs: {
      "id": "plan-summary",
      "d": "M16.5-19.25H2.75A2.75,2.75,0,0,0,0-16.5V0A2.75,2.75,0,0,0,2.75,2.75H16.5A2.75,2.75,0,0,0,19.25,0V-16.5A2.751,2.751,0,0,0,16.5-19.25ZM2.75-14.437a.694.694,0,0,1,.688-.687H4.813a.692.692,0,0,1,.688.688v1.375a.69.69,0,0,1-.687.688H3.438a.691.691,0,0,1-.687-.687ZM5.5-2.062a.69.69,0,0,1-.687.688H3.438a.691.691,0,0,1-.687-.687V-3.437a.694.694,0,0,1,.688-.687H4.813a.692.692,0,0,1,.688.688ZM7.017-9.483,4.611-7.077a.687.687,0,0,1-.486.2.689.689,0,0,1-.486-.2L2.608-8.108a.687.687,0,0,1,0-.972.687.687,0,0,1,.972,0l.545.547,1.92-1.92a.687.687,0,0,1,.972,0,.684.684,0,0,1,0,.971Zm8.8,7.421H8.937A.69.69,0,0,1,8.25-2.75a.689.689,0,0,1,.688-.687h6.875a.688.688,0,0,1,.688.688A.689.689,0,0,1,15.813-2.062Zm0-5.5H8.937A.69.69,0,0,1,8.25-8.25a.689.689,0,0,1,.688-.687h6.875a.69.69,0,0,1,.688.688A.69.69,0,0,1,15.813-7.562Zm0-5.5H8.937a.69.69,0,0,1-.687-.687.689.689,0,0,1,.688-.687h6.875a.69.69,0,0,1,.688.688A.69.69,0,0,1,15.813-13.062Z",
      "transform": "translate(0 19.25)",
      "fill": "currentColor"
    }
  })])]), _vm._v("\n              Plan summary\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'billingContact'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('billingContact')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20.625",
      "height": "22",
      "viewBox": "0 0 20.625 22"
    }
  }, [_c('path', {
    attrs: {
      "id": "billing-contact",
      "d": "M16.5-19.25H4.125a2.75,2.75,0,0,0-2.75,2.75V0a2.75,2.75,0,0,0,2.75,2.75H16.5A2.75,2.75,0,0,0,19.25,0V-16.5A2.751,2.751,0,0,0,16.5-19.25Zm-6.187,5.5A2.75,2.75,0,0,1,13.063-11a2.75,2.75,0,0,1-2.75,2.75A2.75,2.75,0,0,1,7.563-11,2.751,2.751,0,0,1,10.313-13.75Zm4.125,11H6.188A.69.69,0,0,1,5.5-3.437,3.437,3.437,0,0,1,8.938-6.875h2.75a3.438,3.438,0,0,1,3.438,3.438A.69.69,0,0,1,14.438-2.75ZM21.313-16.5h-.687v4.125h.688A.69.69,0,0,0,22-13.062v-2.75A.688.688,0,0,0,21.313-16.5Zm0,5.5h-.687v4.125h.688A.69.69,0,0,0,22-7.562v-2.75A.69.69,0,0,0,21.313-11Zm0,5.5h-.687v4.125h.688A.688.688,0,0,0,22-2.062v-2.75A.69.69,0,0,0,21.313-5.5Z",
      "transform": "translate(-1.375 19.25)",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), (_vm.canEditBillingContact === false) ? [_vm._v("Billing contact")] : [_vm._v("Edit billing contact")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'billingDetails'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('billingDetails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24.75",
      "height": "19.25",
      "viewBox": "0 0 24.75 19.25"
    }
  }, [_c('path', {
    attrs: {
      "id": "billing-details",
      "d": "M22-17.875H2.75A2.75,2.75,0,0,0,0-15.125v13.75a2.75,2.75,0,0,0,2.75,2.75H22a2.75,2.75,0,0,0,2.75-2.75v-13.75A2.751,2.751,0,0,0,22-17.875ZM2.711-7.562A.687.687,0,0,1,3.4-8.25H7.524a.687.687,0,0,1,.688.688v1.375a.688.688,0,0,1-.687.688H3.4a.688.688,0,0,1-.687-.687V-7.562ZM6.875-1.719a.345.345,0,0,1-.344.344H3.094a.344.344,0,0,1-.344-.344v-.687a.344.344,0,0,1,.344-.344H6.531a.344.344,0,0,1,.344.344Zm8.25,0a.344.344,0,0,1-.344.344H8.594a.345.345,0,0,1-.344-.344v-.687a.344.344,0,0,1,.344-.344h6.149a.344.344,0,0,1,.344.344ZM16.5-6.187a.688.688,0,0,1-.687.688h-5.5a.688.688,0,0,1-.687-.687V-7.562a.681.681,0,0,1,.649-.687h5.5a.687.687,0,0,1,.688.688Zm5.5,0a.688.688,0,0,1-.687.688h-2.75a.69.69,0,0,1-.687-.687V-7.562a.687.687,0,0,1,.688-.687h2.75A.69.69,0,0,1,22-7.562Zm0-5.5a.69.69,0,0,1-.687.688H17.188a.688.688,0,0,1-.687-.687v-2.75a.687.687,0,0,1,.688-.687h4.125a.69.69,0,0,1,.688.688Z",
      "transform": "translate(0 17.875)",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), (_vm.canEditBillingDetails === false) ? [_vm._v("Billing details")] : [_vm._v("Edit billing details")]], 2)]), _vm._v(" "), (_vm.invoices && _vm.invoices.length > 0) ? _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'billingInvoices'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('billingInvoices')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16.5",
      "height": "22",
      "viewBox": "0 0 16.5 22"
    }
  }, [_c('path', {
    attrs: {
      "id": "invoices",
      "d": "M14.25-.25v5.5h5.5Zm1.375,11H7.375V13.5h8.25Zm-2.75-5.5V-.25H5.313A2.062,2.062,0,0,0,3.25,1.813V19.688A2.063,2.063,0,0,0,5.313,21.75H17.688a2.062,2.062,0,0,0,2.063-2.062V6.625H14.289A1.382,1.382,0,0,1,12.875,5.25ZM6,2.844A.346.346,0,0,1,6.344,2.5H9.781a.346.346,0,0,1,.344.344v.688a.345.345,0,0,1-.344.344H6.344A.346.346,0,0,1,6,3.531Zm0,2.75a.346.346,0,0,1,.344-.344H9.781a.345.345,0,0,1,.344.344v.688a.345.345,0,0,1-.344.344H6.344A.346.346,0,0,1,6,6.281ZM17,18.656a.346.346,0,0,1-.344.344H13.219a.345.345,0,0,1-.344-.344v-.687a.346.346,0,0,1,.344-.344h3.438a.346.346,0,0,1,.344.344Zm0-8.594v4.125a.685.685,0,0,1-.687.688H6.688A.685.685,0,0,1,6,14.188V10.063a.685.685,0,0,1,.688-.687h9.625A.684.684,0,0,1,17,10.063Z",
      "transform": "translate(-3.25 0.25)",
      "fill": "currentColor"
    }
  })])]), _vm._v("\n              Documents\n            ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [(_vm.currentPlan && _vm.currentPlan.plan) ? _c('div', {
    ref: "subscriptionDetails",
    staticClass: "content-section profile-section no-margin-top",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'subscriptionDetails'
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("\n              Plan summary\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "edit-details-billing-group"
  }, [(_vm.company.billingDetailsData.disconnectedFromBilling === 0 && _vm.getUserRole === 'ca') ? _c('a', {
    staticClass: "edit-details edit-details-billing border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.initCancelSubscription()
      }
    }
  }, [_c('span', {
    staticClass: "cancel-subscription color-1-100"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "id": "times",
      "fill": "currentColor",
      "d": "M8-14A8,8,0,0,0,0-6,8,8,0,0,0,8,2a8,8,0,0,0,8-8A8,8,0,0,0,8-14Zm2.5,9.469a.75.75,0,0,1,0,1.061.75.75,0,0,1-1.061,0L8-4.941,6.53-3.471a.75.75,0,0,1-1.061,0,.75.75,0,0,1,0-1.061L6.939-6,5.469-7.5a.75.75,0,0,1,0-1.061.75.75,0,0,1,1.061,0L8-7.059l1.47-1.47a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061L9.061-6Z",
      "transform": "translate(0 14)"
    }
  })])]), _vm._v("\n                Cancel subscription\n              ")]) : _vm._e(), _vm._v(" "), (_vm.invoicesToBePaid && _vm.canEditPayment === false && _vm.getUserRole === 'ca') ? _c('a', {
    staticClass: "edit-details edit-details-pay-now border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditPayment()
      }
    }
  }, [_c('span', {
    staticClass: "pay-now color-1-100"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "18",
      "height": "14",
      "viewBox": "0 0 18 14"
    }
  }, [_c('path', {
    attrs: {
      "id": "credit-card",
      "d": "M16-13H2a2,2,0,0,0-2,2V-1A2,2,0,0,0,2,1H16a2,2,0,0,0,2-2V-11A2,2,0,0,0,16-13ZM1.972-5.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-1ZM5-1.25A.251.251,0,0,1,4.75-1H2.25A.25.25,0,0,1,2-1.25v-.5A.25.25,0,0,1,2.25-2h2.5A.25.25,0,0,1,5-1.75Zm6,0a.25.25,0,0,1-.25.25H6.25A.251.251,0,0,1,6-1.25v-.5A.25.25,0,0,1,6.25-2h4.472a.25.25,0,0,1,.25.25ZM12-4.5a.5.5,0,0,1-.5.5h-4A.5.5,0,0,1,7-4.5v-1A.5.5,0,0,1,7.472-6h4a.5.5,0,0,1,.5.5Zm4,0a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5Zm0-4a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Z",
      "transform": "translate(0 13)",
      "fill": "currentColor"
    }
  })])]), _vm._v("\n                Pay now\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data__wrapper"
  }, [_c('div', {
    staticClass: "subscription__plan-data blue-section"
  }, [_c('p', {
    staticClass: "subscription__plan-data--text"
  }, [_vm._v("\n                  You pay "), _c('strong', [_vm._v("£" + _vm._s(_vm.planPrice) + " "), (_vm.vatDisplay) ? [_vm._v("(including VAT)")] : _vm._e(), _vm._v(" / " + _vm._s(_vm.currentPlanSubscriptionPaymentPeriod))], 2), _vm._v(" via "), (_vm.profile && _vm.profile.company && _vm.profile.company.payment_method === 0) ? [_vm._v("Credit Card")] : [_vm._v("Bank Transfer")], _vm._v(" for your "), _c('strong', [_vm._v(_vm._s(_vm.currentPlan.plan.name) + " plan for " + _vm._s(_vm.currentPlanSize) + " organisations")]), _vm._v(".\n                ")], 2), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Billing period")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.currentPlanPaymentPeriod))])]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Commitment period")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.currentPlanCommitment))])]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Active until")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.commitmentExpiryDate))])]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column"
  }, [_c('div', {
    staticClass: "subscription__plan-data--details__column--label"
  }, [_vm._v("Next payment date")]), _vm._v(" "), _c('div', {
    staticClass: "subscription__plan-data--details__column--text"
  }, [_vm._v(_vm._s(_vm.nextPaymentDate))])])])])]), _vm._v(" "), (_vm.invoicesToBePaid && _vm.canEditPayment === true) ? [_c('div', {
    staticClass: "complete-profile__content--form__head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-payment-area--info"
  }, [_c('div', {
    staticClass: "card-payment-area--info__secure-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-shield-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "shield-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M466.5 83.71l-192-80c-4.875-2.031-13.16-3.703-18.44-3.703c-5.312 0-13.55 1.672-18.46 3.703L45.61 83.71C27.7 91.1 16 108.6 16 127.1C16 385.2 205.2 512 255.9 512C307.1 512 496 383.8 496 127.1C496 108.6 484.3 91.1 466.5 83.71zM352 200c0 5.531-1.901 11.09-5.781 15.62l-96 112C243.5 335.5 234.6 335.1 232 335.1c-6.344 0-12.47-2.531-16.97-7.031l-48-48C162.3 276.3 160 270.1 160 263.1c0-12.79 10.3-24 24-24c6.141 0 12.28 2.344 16.97 7.031l29.69 29.69l79.13-92.34c4.759-5.532 11.48-8.362 18.24-8.362C346.4 176 352 192.6 352 200z"
    }
  })])]), _vm._v(" "), _c('svg', {
    staticClass: "svg-inline--fa fa-credit-card-front",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "credit-card-front",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 576 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M512 32h-448c-35.35 0-64 28.65-64 64v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96C576 60.65 547.3 32 512 32zM63.1 272c0-8.838 7.164-16 16-16h96c8.836 0 16 7.162 16 16v32c0 8.836-7.164 16-16 16h-96c-8.836 0-16-7.164-16-16V272zM160 408C160 412.4 156.4 416 152 416h-80C67.58 416 64 412.4 64 408l0-16c0-4.42 3.582-8 8-8h80c4.418 0 8 3.58 8 8L160 408zM352 408c0 4.418-3.582 8-8 8h-144C195.6 416 192 412.4 192 408l0-16c0-4.42 3.582-8 8-8h143.1c4.418 0 8 3.58 8 8L352 408zM384 304c0 8.836-7.164 16-16 16h-128c-8.836 0-16-7.164-16-16v-32c0-8.838 7.164-16 15.1-16h128c8.836 0 16 7.162 16 16L384 304zM512 304c0 8.836-7.164 16-16 16h-64C423.2 320 416 312.8 416 304l0-32c0-8.838 7.164-16 16-16H496C504.8 256 512 263.2 512 272V304zM512 176C512 184.8 504.8 192 496 192h-96c-8.836 0-16-7.164-16-16v-64c0-8.838 7.164-16 16-16H496C504.8 96 512 103.2 512 112V176z"
    }
  })]), _vm._v(" "), _c('strong', [_vm._v("SECURE")]), _vm._v(" PAY\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-payment-area"
  }, [_c('div', {
    attrs: {
      "id": "stripePaymentIframe"
    },
    on: {
      "mousedown": function($event) {
        return _vm.paymentIframeActioned()
      }
    }
  }, [_c('iframe', {
    attrs: {
      "src": _vm.stripeBillingUrl
    }
  })]), _vm._v(" "), (_vm.payment.error) ? _c('div', {
    staticClass: "card-payment-area--error"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-error"
    }
  }, [_vm._v(_vm._s(_vm.payment.error))])]) : _vm._e()])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "billingContact",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'billingContact' || _vm.canEditBillingContact,
      'no-margin-top': !(_vm.currentPlan && _vm.currentPlan.plan)
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditBillingContact === false) ? [_vm._v("Billing contact")] : [_vm._v("Edit billing contact")]], 2), _vm._v(" "), (_vm.canEditBillingContact === false && (_vm.getUserRole === 'gm' || _vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('a', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditBillingContact()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n              Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "billing-first-name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingContactData.firstName),
      expression: "company.billingContactData.firstName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name'),
      'is-locked': !_vm.canEditBillingContact,
      'not-empty': _vm.company.billingContactData.firstName !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingContact === false,
      "data-lpignore": "true",
      "id": "billing-first-name",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.company.billingContactData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingContactData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "billing-phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingContactData.phone),
      expression: "company.billingContactData.phone"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number'),
      'is-locked': !_vm.canEditBillingContact,
      'not-empty': _vm.company.billingContactData.phone !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingContact === false,
      "data-lpignore": "true",
      "id": "billing-phone",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.company.billingContactData.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingContactData, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "billing-first-name"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingContactData.lastName),
      expression: "company.billingContactData.lastName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name'),
      'is-locked': !_vm.canEditBillingContact,
      'not-empty': _vm.company.billingContactData.lastName !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingContact === false,
      "data-lpignore": "true",
      "id": "billing-last-name",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.company.billingContactData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingContactData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingContactData.email),
      expression: "company.billingContactData.email"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email'),
      'is-locked': !_vm.canEditBillingContact,
      'not-empty': _vm.company.billingContactData.email !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingContact === false,
      "data-lpignore": "true",
      "id": "new-user-email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.company.billingContactData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingContactData, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditBillingContact && (_vm.getUserRole === 'gm' || _vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditBillingContact()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyBillingContactData()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "billingDetails",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'billingDetails' || _vm.canEditBillingDetails
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditBillingDetails === false) ? [_vm._v("Billing details")] : [_vm._v("Edit billing details")]], 2), _vm._v(" "), (_vm.canEditBillingDetails === false && (_vm.getUserRole === 'gm' || _vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('a', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditBillingDetails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n              Edit\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-organisation"
    }
  }, [_vm._v("Organisation name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.organisationName),
      expression: "company.billingDetailsData.organisationName"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Billing organisation name'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.organisationName !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-organisation",
      "name": "Billing organisation name"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.organisationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "organisationName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Billing organisation name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing organisation name')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-organisation-type"
    }
  }, [_vm._v("Organisation type*")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Billing organisation type'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.organisationType !== null
    }],
    attrs: {
      "disabled": _vm.canEditBillingDetails === false,
      "searchable": true,
      "clearable": false,
      "options": _vm.companyOrganizationTypes,
      "data-lpignore": "true",
      "name": "Organisation type",
      "id": "complete-profile-billing-organisation-type"
    },
    model: {
      value: (_vm.company.billingDetailsData.organisationType),
      callback: function($$v) {
        _vm.$set(_vm.company.billingDetailsData, "organisationType", $$v)
      },
      expression: "company.billingDetailsData.organisationType"
    }
  }), _vm._v(" "), (this.errors.has('Billing organisation type')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Billing organisation type')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-vat"
    }
  }, [_vm._v("VAT")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.organisationVat),
      expression: "company.billingDetailsData.organisationVat"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('VAT'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.organisationVat !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-vat",
      "name": "VAT"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.organisationVat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "organisationVat", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('VAT')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('VAT')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-county"
    }
  }, [_vm._v("County/State")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.addressCounty),
      expression: "company.billingDetailsData.addressCounty"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('County/State'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.addressCounty !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-county",
      "name": "County/State"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.addressCounty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "addressCounty", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('County/State')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('County/State')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-street"
    }
  }, [_vm._v("Street address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.addressStreet),
      expression: "company.billingDetailsData.addressStreet"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Street address'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.addressStreet !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-street",
      "name": "Street address"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.addressStreet)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "addressStreet", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Street address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Street address')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-postal-code"
    }
  }, [_vm._v("Postcode*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.addressPostalCode),
      expression: "company.billingDetailsData.addressPostalCode"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Postcode'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.addressPostalCode !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-postal-code",
      "name": "Postcode"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.addressPostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "addressPostalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Postcode')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Postcode')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-city"
    }
  }, [_vm._v("City*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.addressCity),
      expression: "company.billingDetailsData.addressCity"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('City'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.addressCity !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-city",
      "name": "City"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.addressCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "addressCity", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('City')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('City')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "complete-profile-billing-address-country"
    }
  }, [_vm._v("Country*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.billingDetailsData.addressCountry),
      expression: "company.billingDetailsData.addressCountry"
    }, {
      name: "validate",
      rawName: "v-validate.persist",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "persist": true
      }
    }],
    staticClass: "form-control form-control__input background-1-10-disabled border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Country'),
      'is-locked': !_vm.canEditBillingDetails,
      'not-empty': _vm.company.billingDetailsData.addressCountry !== ''
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditBillingDetails === false,
      "data-lpignore": "true",
      "id": "complete-profile-billing-address-country",
      "name": "Country"
    },
    domProps: {
      "value": (_vm.company.billingDetailsData.addressCountry)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.billingDetailsData, "addressCountry", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Country')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Country')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditBillingDetails && (_vm.getUserRole === 'gm' || _vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditBillingDetails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyBillingDetailsData()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()])]), _vm._v(" "), (_vm.invoices && _vm.invoices.length > 0) ? _c('div', {
    ref: "billingInvoices",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'billingInvoices'
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("\n              Documents\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data border-1-20"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(invoice, i) {
    return _c('tr', {
      attrs: {
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.downloadInvoice(invoice.id)
        }
      }
    }, [_c('td', {
      staticClass: "created-cell cellpadding text-center border-1-20",
      attrs: {
        "data-title": "Invoice number:"
      }
    }, [_vm._v(_vm._s(invoice.columns.number ? invoice.columns.number : 'n/a'))]), _vm._v(" "), _c('td', {
      staticClass: "last-login-cell cellpadding text-center border-1-20",
      attrs: {
        "data-title": "Issue date:"
      }
    }, [_vm._v(_vm._s(invoice.columns.issueDate ? _vm.convertDate(invoice.columns.issueDate.text, '.') : 'n/a'))]), _vm._v(" "), _c('td', {
      staticClass: "created-cell cellpadding text-center border-1-20",
      attrs: {
        "data-title": "Billed:"
      }
    }, [_vm._v(_vm._s(invoice.columns.billed ? ('£' + invoice.columns.billed) : 'n/a'))]), _vm._v(" "), _c('td', {
      staticClass: "status-cell cellpadding text-center border-1-20",
      class: [{
        expired: invoice.columns.expired
      }],
      attrs: {
        "data-title": "Status:"
      }
    }, [_vm._v(_vm._s(invoice.columns.status ? invoice.columns.status : 'n/a'))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Card details")]), _vm._v(" "), _c('p', [_vm._v("\n                    Please fill in the fields below with the required details. Learn more about each section by tapping the ‘i’ icon next to the field label."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "table-head-mobile-custom background-1-40-before border-1-40"
  }, [_c('tr', [_c('th', {
    staticClass: "column-created-head table-head-ceil background-1-10 border-1-20",
    attrs: {
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-text"
  }, [_vm._v("\n                    Document number\n                  ")])]), _vm._v(" "), _c('th', {
    staticClass: "column-active-head table-head-ceil background-1-10 border-1-20",
    attrs: {
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-text"
  }, [_vm._v("\n                    Issue date\n                  ")])]), _vm._v(" "), _c('th', {
    staticClass: "column-active-head table-head-ceil background-1-10 border-1-20",
    attrs: {
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-text"
  }, [_vm._v("\n                    Amount\n                  ")])]), _vm._v(" "), _c('th', {
    staticClass: "column-active-head table-head-ceil background-1-10 border-1-20",
    attrs: {
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-text"
  }, [_vm._v("\n                    Status\n                  ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cfc5a04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/BillingProfile.vue
// module id = 989
// module chunks = 0